import React from 'react';
import { Zap } from 'lucide-react';
export function Header() {
  return <header className="sticky top-0 z-50 w-full bg-slate-950/80 backdrop-blur-md border-b border-slate-800" data-id="element-65">
      <div className="max-w-5xl mx-auto px-4 h-16 flex items-center justify-between" data-id="element-66">
        <div className="flex items-center gap-2" data-id="element-67">
          <Zap className="w-6 h-6 text-blue-500" data-id="element-68" />
          <span className="font-bold text-lg tracking-tight text-slate-100 hidden sm:block" data-id="element-69">
            EL INTERRUPTOR DE NITRÓGENO
          </span>
          <span className="font-bold text-lg tracking-tight text-slate-100 sm:hidden" data-id="element-70">
            NITRÓGENO
          </span>
        </div>
        <a href="#comprar" className="flex justify-center items-center bg-blue-600 hover:bg-blue-500 text-white font-semibold py-2 px-4 rounded-full transition-all duration-300 shadow-[0_0_15px_rgba(37,99,235,0.4)] hover:shadow-[0_0_25px_rgba(37,99,235,0.6)] hover:scale-105 active:scale-95 text-sm" data-id="element-71">
          Descargar Protocolo
        </a>
      </div>
    </header>;
}